module.exports = __webpack_public_path__ + "static/shop-earn-cashback-tablet-53a1cb32fd5bda433edabb249479960e.png";